<navbar [currentUser]="loggedInUser$ | async"></navbar>
